(function () {
  function initCarousel(root) {
    const viewport = root.querySelector('[data-aa-carousel-viewport]');
    const track = root.querySelector('[data-aa-carousel-track]');
    const btnPrev = root.querySelector('[data-aa-carousel-prev]');
    const btnNext = root.querySelector('[data-aa-carousel-next]');

    if (!viewport || !track || !btnPrev || !btnNext) return;

    const MOVE_BY = 3;

    function getItemStep() {
      const firstItem = track.querySelector('.aa-color-carousel__item');
      if (!firstItem) return 140;

      const itemRect = firstItem.getBoundingClientRect();
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.gap || styles.columnGap || '12') || 12;
      return Math.round(itemRect.width + gap);
    }

    function updateButtons() {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const current = Math.round(viewport.scrollLeft);

      btnPrev.disabled = current <= 2;
      btnNext.disabled = current >= Math.round(maxScroll) - 2;

      const hasOverflow = maxScroll > 5;
      btnPrev.style.visibility = hasOverflow ? 'visible' : 'hidden';
      btnNext.style.visibility = hasOverflow ? 'visible' : 'hidden';
    }

    btnPrev.addEventListener('click', () => {
      viewport.scrollBy({ left: -getItemStep() * MOVE_BY, behavior: 'smooth' });
    });

    btnNext.addEventListener('click', () => {
      viewport.scrollBy({ left: getItemStep() * MOVE_BY, behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    // Center active on load
    const active = track.querySelector('.aa-color-carousel__item.is-active');
    if (active) {
      const activeRect = active.getBoundingClientRect();
      const viewportRect = viewport.getBoundingClientRect();
      const offset = activeRect.left - viewportRect.left - (viewportRect.width / 2) + (activeRect.width / 2);
      viewport.scrollLeft += offset;
    }

    updateButtons();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-aa-color-carousel]').forEach(initCarousel);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const scope = event.target || document;
    scope.querySelectorAll('[data-aa-color-carousel]').forEach(initCarousel);
  });
})();